import ko from "knockout";
import $ from "jquery";
import moment from "moment";
import {throttle} from "throttle-debounce";
import {currentBrowser} from "./tools";
import Entity from "./entity";

export default function($app) {
	const $ui = $app.require('ui');
    const $comet = $app.require('comet');
	const $locale = $app.require('locale');

	let episodeContainer;
	let episodeSearch;

	this.titleType = ko.computed(() => {
		if($app.event().status() === 'stop') return 'records';
		if(['idle', 'live', 'pause'].indexOf($app.event().status()) >= 0 && $app.event().stream().length > 1) return 'live';
		return 'episodes';
	});
	this.title = ko.computed(() => $locale.get('episode.title.' + this.titleType()));
	this.position = $app.event().moduleEpisode.position;
	this.name = 'episode';
	this.isEnabled = ko.observable($app.event().episode().length > 0 && $app.event().moduleEpisode.position() !== 'hide');
	this.isLikeEnabled = ko.computed(() => $app.event().moduleEpisode.like());

	this.filterText = ko.observable('');

	this.lastEpisode = ko.computed(() => {
		let lastEpisode = null;
		$app.event().episode().forEach((episode) => {
			if(episode.isDelay()) return;
			if(!lastEpisode || lastEpisode.timeStop() < episode.timeStop()) {
				lastEpisode = episode;
			}
		});
		return lastEpisode;
	});

	this.episode = ko.computed(() => {
		const filterText = this.filterText().toLowerCase();
		let episodes = $app.event().episode();

		if(filterText) {
			episodes = episodes.filter((episode) => {
				if(episode.isDelay()) return true;
				let filterFound = false;

				['name', 'info', 'section'].forEach((name) => {
					const text = episode[name]();
					if(text.toLowerCase && -1 !== text.toLowerCase().indexOf(filterText)) {
						filterFound = true;
					}
				});

				[episode.speakers(), episode.moderators()].forEach((memberList) => {
					if(memberList instanceof Array) {
						memberList.forEach((member) => {
							['fullnameRu', 'fullnameEn', 'fullname', 'en_fullname', 'description', 'en_description'].forEach((key) => {
								const text = String(member[key] || '');
								if(-1 !== text.toLowerCase().indexOf(filterText)) {
									filterFound = true;
								}
							});
						});
					}
				});

				return filterFound;
			});
		} else if($app.event().stream().length > 1) {
			switch($app.event().status()) {
				case 'idle':
					episodes = [];
					break;
				case 'live':
					episodes = episodes.filter((episode) => {
						return !episode.isDelay()
							&& (episode.type() === 'live' || (episode.type() === 'record' && episode === $app.currentEpisode()))
							;
					});
					break;
				case 'paused':
					episodes = episodes.filter((episode) => {
						return !episode.isDelay()
							&& (episode.type() === 'live' || (episode.type() === 'record' && episode === $app.currentEpisode()))
							;
					});
					break;
				case 'stop':
					episodes = episodes.filter((episode) => {
						return !episode.isDelay()
							&& (episode.type() === 'live' || episode.type() === 'record');
					});
					break;
			}
		}

		return episodes;
	});

	this.episodeByDate = ko.computed(() => {
		const date = {};
		let lastDateKey;
		const list = [];

		this.episode().forEach((episode) => {
			let dateKey = moment.unix(episode.timeStart()).format('YYYY-MM-DD');
			if(episode.isDelay()) {
				dateKey = lastDateKey;
			}
			lastDateKey = dateKey;
			if(!date[dateKey]) {
				date[dateKey] = {
					time: episode.timeStart,
					episode: []
				};
				list.push(date[dateKey]);
			}
			date[dateKey].episode.push(episode);
		});
		return list;
	});

	this.scrollToEpisode = (id) => {
		const episode = episodeContainer.find('.episode_' + id);
		if(!episode.length) {
			return;
		}

		const scrollContainer = (this.position() === 'bottom' || currentBrowser.isMobile())
			? episodeContainer.parent()
			: episodeContainer;

		const offset = scrollContainer.scrollTop() + episode.position().top;
		scrollContainer.animate({scrollTop: offset});
	};

	this.like = (episode, status) => {
		if (!$app.require('auth').isLoggedIn()) {
			$app.require('auth').show($locale.get('episode.likeAuth'));
			return;
		}

		episode = episode || $app.currentEpisode();
		if(!episode) return;
		status = typeof status != 'undefined' ? status : !episode.liked();

		episode.setLiked(status);
	};

	this.init = () => {
		episodeContainer = $('#episode-container .episode-list');
		episodeSearch = $('#episode-container input#episode-search');
		episodeSearch.on('keyup', throttle(300, (event) => {
			if(event.keyCode === 27) {
				event.target.value = '';
				episodeSearch.fadeOut(() =>
					episodeContainer.removeClass('search')
				);
			}
			this.filterText(event.target.value.toLowerCase());
		}));
		$ui.playerSize.isCompactShow.subscribe(() => {
			if($app.currentEpisode()) {
				this.scrollToEpisode($app.currentEpisode().id());
			}
		});

		$app.require('auth').isLoggedIn.subscribe((isLoggedIn) => {
            if (!isLoggedIn) {
                $app.resetEpisodeLikes();
            }
        });

		$app.currentEpisode.subscribe((episode) => {
			if(episode) {
				this.scrollToEpisode(episode.id());
			}
		});

	};

	this.toggleEpisodeInfo = (episode, event) => {
		const $episodeElement = $(event.target).parent();
		const $infoContainer = $episodeElement.find('.episode-infoBox');
		const $episodeContainer = $episodeElement.closest('.episode-list');

		if($infoContainer.hasClass('show')) {
			$infoContainer.removeClass('show');
		} else {
			$infoContainer.addClass('show');

			setTimeout(() => {
				const containerScrollTop = $episodeContainer.scrollTop();
				const containerHeight = $episodeContainer.innerHeight();
				const containerScrollBottom = containerScrollTop + containerHeight;

				const episodeOffsetTop = $episodeElement.get(0).offsetTop;
				const episodeHeight = $episodeElement.get(0).offsetHeight;
				const episodeBottomPosition = episodeOffsetTop + episodeHeight;
				if(containerScrollBottom < episodeBottomPosition) {
					$episodeContainer.animate({scrollTop: episodeBottomPosition - containerHeight + parseInt($episodeElement.css('margin-bottom'))});
				}
			}, 100);
		}
	};

    const updateEpisode = (data) => {
        delete data.liked;
        const instance = Entity.Event.Stream.Episode.getInstance(data.id);
        if (instance) {
            instance.fillFrom(data);
        } else {
            new Entity.Event.Stream.Episode(data);
        }
    };
    const removeEpisode = (id) => {
        const instance = Entity.Event.Stream.Episode.getInstance(id);
        if (instance) {
            instance.remove();
        }
    };
    const updateEpisodeLike = ({id, like}) => {
        const instance = Entity.Event.Stream.Episode.getInstance(id);
        if (instance) {
            instance.like(like);
        }
    };

	$app.on('start', () => {
		if(!this.isEnabled()) {
			return;
		}

		this.uiTab = new $ui.Tab(this);

		this.uiButton = new $ui.Button({
			position: this.position,
			icon: 'search',
			title: $locale.get('episode.search.title')
		});
		this.uiButton.on('click', () => {
			this.uiTab.open();
			if(episodeSearch.is(':visible')) {
				episodeSearch.fadeOut(() => episodeContainer.removeClass('search'));
			} else {
				episodeContainer.addClass('search');
				episodeSearch.fadeIn(() => episodeSearch.focus());
			}
		});

		setTimeout(() => this.init(), 0);
	});

    $comet
        .on('create:episode', updateEpisode)
        .on('update:episode', updateEpisode)
        .on('update:episode/like', updateEpisodeLike)
        .on('delete:episode', ({id}) => removeEpisode(id))
    ;
};
